<form-popup
    titleText="User Status Update"
    saveText="Confirm"
    [width]="520"
    [visible]="visible"
    [isSaveDisabled]="isSaving"
    [isSaveVisible]="!isReadOnly"
    (open)="reset()"
    (save)="confirm()"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="d-flex flex-column gap-3">
        <div>
            <label class="form-label">Effective Date*:</label>
            <dx-date-box
                [(value)]="effectiveDate"
                type="date"
                pickerType="calendar"
                [displayFormat]="dateFormat"
                [readOnly]="isReadOnly"
                stylingMode="filled"
            >
                <dx-validator>
                    <dxi-validation-rule type="required" message="Effective Date is required"></dxi-validation-rule>
                </dx-validator>
            </dx-date-box>
        </div>
        <div>
            <label class="form-label">Can the Position ID be delimited?*:</label>
            <dx-select-box
                [(value)]="positionDelimited"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [readOnly]="isReadOnly"
                stylingMode="filled"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="isSelected" message="Please select Yes or No"></dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </div>
        <div>
            <label class="form-label">Ticket Number ID*:</label>
            <dx-text-box [(value)]="ticketNumber" [maxLength]="50" [readOnly]="isReadOnly" stylingMode="filled">
                <dx-validator>
                    <dxi-validation-rule type="required" message="Ticket Number ID is required"></dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </div>
        <div>
            <label class="form-label">Note:</label>
            <dx-text-area
                [(value)]="note"
                [height]="100"
                [maxLength]="3000"
                [readOnly]="isReadOnly"
                placeholder="Enter Note Details"
                stylingMode="filled"
            ></dx-text-area>
        </div>
        @if (record) {
            <div>
                <label class="form-label">Attachments:</label>
                @for (file of record.attachments; track file.fileUrl) {
                    <div>
                        <a href="#" [appSignedLink]="file.fileUrl" class="text-decoration-none">
                            <i class="dx-icon-attach"></i> {{ file.fileName }}
                        </a>
                    </div>
                } @empty {
                    <div class="text-muted">No attachments</div>
                }
            </div>
        } @else {
            <file-upload label="Attachments:" [(value)]="files"></file-upload>
        }
    </div>
</form-popup>
